/** List fields returned by the related-treatment endpoint. */
export interface PatientTreatmentRecord {
    readonly id: string;
    readonly tinyId?: string | null;
    readonly treatmentTypeName: string;
    readonly submittedDate?: string | null;
    readonly statusName?: string | null;
    readonly designerId?: string | null;
}
